import React from 'react';
import { Student } from '../types';

interface Props {
  student: Pick<Student, 'registrationStatus'>;
  className?: string;
}

/**
 * Pending-registration pill. Renders nothing when the student is COMPLETE so
 * lists for fully-registered children stay clean. Default color is amber to
 * signal "action needed" without screaming "error".
 */
const RegistrationStatusBadge: React.FC<Props> = ({ student, className = '' }) => {
  if ((student.registrationStatus || 'PENDING') === 'COMPLETE') return null;
  return (
    <span
      data-testid="registration-pending-badge"
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 ${className}`}
    >
      Pending registration
    </span>
  );
};

export default RegistrationStatusBadge;
